import Vue from 'vue';

import { Regex } from './utils/regex';

/**
 * Numbers only directive.
 */
Vue.directive('numbers', {
  bind(el: HTMLInputElement) {
    el.addEventListener('input', () => {
      if (!Regex.Numbers.test(el.value)) {
        el.value = el.value.slice(0, -1);
        el.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  },
});
